module.exports = __webpack_public_path__ + "img/bg_detection@2x.b1089145.png";